import {
    IconArrowRight,
    IconCircle,
    IconHeart,
    IconHorizontalLine,
    IconSquare,
    IconStar,
    IconTools,
    IconToolsPink,
    IconTriangle,
    IconVerticalLine,
    ImageCustomTemplate1,
    ImageCustomTemplate2,
    ImageTemplate1,
    ImageTemplate2,
} from '@/assets';
import theme from '@/theme';
import { pageSizes } from './layoutConstants';

export const sideBarpillsList = {
    template: 'Template',
    text: 'Text',
    image: 'Image',
    shape: 'Shape',
    qr: 'QR',
    whiteLabel: 'White-label',
};

export const ButtonVarients = {
    primary: 'primary',
    secondary: 'secondary',
};
export const shapes = {
    circle: 'circle',
    square: 'square',
    triangle: 'triangle',
    arrowRight: 'arrowRight',
    horizontalLine: 'horizontalLine',
    verticalLine: 'verticalLine',
    star: 'star',
    heart: 'heart',
};
export const defaultSideBarImagesList = [IconTools, IconToolsPink];
export const textList = [
    {
        text: 'HEADING_1',
        fontFamily: 'Open Sans',
        fontSize: 18,
        color: '#333333',
        fontWeight: theme.fontWeights[700],
        textDecoration: 'normal',
        fontStyle: 'normal',
        textAlign: 'left',
        width: 125,
    },
    {
        text: 'HEADING_2',
        fontFamily: 'Open Sans',
        fontSize: 16,
        color: '#333333',
        fontWeight: theme.fontWeights[700],
        textDecoration: 'normal',
        fontStyle: 'normal',
        textAlign: 'left',
    },
    {
        text: 'SCAN_THIS_QR',
        fontFamily: 'Open Sans',
        fontSize: 16,
        color: '#333333',
        fontWeight: theme.fontWeights[400],
        textDecoration: 'normal',
        fontStyle: 'normal',
        textAlign: 'left',
        width: 220,
    },
];
export const elementTypes = {
    pageSize: 'pageSize',
    backgroundColor: 'backgroundColor',
    backgroundImage: 'backgroundImage',
    circle: 'circle',
    square: 'square',
    triangle: 'triangle',
    arrowRight: 'arrowRight',
    horizontalLine: 'horizontalLine',
    verticalLine: 'verticalLine',
    star: 'star',
    heart: 'heart',
    image: 'image',
    qr: 'qr',
    text: 'text',
};
export const shapesList = [
    {
        shape: elementTypes.circle,
        icon: IconCircle,
    },
    {
        shape: elementTypes.square,
        icon: IconSquare,
    },
    {
        shape: elementTypes.triangle,
        icon: IconTriangle,
    },
    {
        shape: elementTypes.arrowRight,
        icon: IconArrowRight,
    },
    {
        shape: elementTypes.horizontalLine,
        icon: IconHorizontalLine,
    },
    {
        shape: elementTypes.verticalLine,
        icon: IconVerticalLine,
    },
    {
        shape: elementTypes.star,
        icon: IconStar,
    },
    {
        shape: elementTypes.heart,
        icon: IconHeart,
    },
];

export const defaultElements = [
    {
        type: elementTypes?.pageSize,
        id: `element${Date.now()}`,
        size: pageSizes?.A4,
        cuttingGuideStroke: 0,
        cuttingGuideStrokeColor: theme.color.black,
    },
];
export const basicTextProps = {
    opacity: 1,
    text: 'Enter Text Here',
    fontSize: 16,
    fontFamily: 'Open Sans',
    color: theme.color.black,
    textDecoration: 'normal',
    fontStyle: 'normal',
    fontWeight: theme.fontWeights[400],
    textAlign: 'left',
    lineHeight: 1,
    // width: 125,
};

export const DEF_TEMPLATE = [
    {
        elements: [
            {
                type: 'pageSize',
                id: 'element-page-size',
                size: 'Ledger',
                cuttingGuideStroke: 4,
                cuttingGuideStrokeColor: '#000000',
            },
            {
                type: 'backgroundColor',
                id: 'element-bg-color',
                color: '#ffffff',
            },
            {
                id: 'element1752140081106',
                x: 14.691584158418777,
                y: 15.683168316831939,
                fill: '#000000',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 8.673168316831626,
                scaleY: 5.526336633663352,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752140215252',
                x: 44.34079207920831,
                y: 37.61658415841626,
                fill: '#ffffff',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 8.080184158415834,
                scaleY: 5.0876683168316665,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element-title-text',
                x: 70.86,
                y: 69.25,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Zgłoś problem',
                fontSize: 59,
                fontFamily: 'Open Sans',
                color: '#000000',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'left',
                width: 750.7,
                fontVariant: 700,
                align: 'left',
                fill: '#000000',
                visible: true,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element-instruction-text',
                x: 72.25,
                y: 264.32,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Zeskanuj kod QR, aby wysłać zgłoszenie bezpośrednio do osoby odpowiedzialnej.',
                fontSize: 36,
                fontFamily: 'Open Sans',
                color: '#000000',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 400,
                textAlign: 'left',
                width: 479.03,
                fontVariant: 400,
                align: 'left',
                fill: '#000000',
                visible: true,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element-location-text',
                x: 72.25,
                y: 477.9500000000001,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Budynek, Piętro, Pokój',
                fontSize: 25,
                fontFamily: 'Open Sans',
                color: '#8c8c8c',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 400,
                textAlign: 'left',
                width: 376.1,
                fontVariant: 400,
                align: 'left',
                fill: '#8c8c8c',
                visible: true,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element-qr',
                type: 'qr',
                height: 110,
                width: 110,
                x: 602.1099999999999,
                y: 283.5,
                fill: '#80D965',
                stroke: '#000000',
                strokeWidth: 0,
                draggable: true,
                qrText: 'https://fixalert.io/',
                opacity: 1,
                logoVisible: false,
                rotation: 0,
                scaleX: 1.995,
                scaleY: 1.995,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
        ],
        image: 'https://i.ibb.co/fzFp3ZZ7/classic-temp-pl.png',
    },
    {
        elements: [
            {
                type: 'pageSize',
                id: 'element1752139646518',
                size: 'A4',
                cuttingGuideStroke: 5,
                cuttingGuideStrokeColor: '#000000',
            },
            {
                id: 'element1752140879571',
                x: 24.25247524752527,
                y: 26.08910891089141,
                fill: '#000000',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 4.504950495049494,
                scaleY: 6.178217821782172,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752141263182',
                x: 149.25247524752461,
                y: 279.7524752475247,
                fill: '#000000',
                stroke: '#ffffff',
                strokeWidth: 1,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 2.0049504950495063,
                scaleY: 2.004950495049506,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                id: 'element1752141318665',
                x: 160.8861386138613,
                y: 291.38613861386136,
                fill: '#FFFFFF',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 1.772277227722773,
                scaleY: 1.772277227722773,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                type: 'qr',
                id: 'element1752140779196',
                width: 110,
                height: 110,
                x: 167.25,
                y: 297.75,
                fill: '#80D965',
                stroke: '#000000',
                strokeWidth: 0,
                draggable: true,
                qrLogo: null,
                qrText: 'https://fixalert.io/',
                opacity: 1,
                logoVisible: false,
                rotation: 0,
                scaleX: 1.4954545454545447,
                scaleY: 1.495454545454545,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                id: 'element1752142031429',
                x: 220.96806950984194,
                y: 79.99999999999994,
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'image',
                draggable: true,
                src: 'data:image/svg+xml,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2034.5%2036.4%22%20width%3D%2250%22%20height%3D%2252%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M29.8%2C4.2c0.7-1%2C0.5-2.3-0.5-3c-0.5-0.3-1-0.5-1.6-0.4c-0.6%2C0.1-1.1%2C0.4-1.4%2C0.9L15.7%2C16l-2.4%2C3.3c-1%2C0.5-7%2C3.2-11.5%2C3.5c0%2C0-0.1%2C0-0.1%2C0c-0.3%2C0-0.5%2C0-0.8%2C0.1c-0.6%2C0.1-0.8%2C0.6-0.9%2C0.8c-0.3%2C1.7%2C0.6%2C3.8%2C2.8%2C6.1c1.5%2C1.7%2C3.2%2C2.9%2C3.2%2C2.9C6.4%2C33%2C6.8%2C33%2C7%2C32.7l2.1-2.3l-1.1%2C3.2c-0.1%2C0.3%2C0%2C0.6%2C0.3%2C0.8c0.1%2C0.1%2C2.6%2C1.6%2C4.3%2C1.9c0.1%2C0%2C0.1%2C0%2C0.2%2C0c0.2%2C0%2C0.4%2C0%2C0.6-0.2c0.6-0.5%2C1.1-1.8%2C1.4-3c0.3-1.2%2C0.6-2.8%2C1-4.8c0.5-2.9%2C0.8-5.7%2C0.9-6.4l2.4-3.3L29.8%2C4.2z%22%2F%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M32.8%2C23.6c-1.1-1.1-2.7-1.8-4.4-1.8c-0.7%2C0-1.4%2C0.1-2.1%2C0.4l-4.6-4.6c-0.3-0.3-0.8-0.3-1.1%2C0.1l-2%2C2.7c-0.2%2C0.3-0.2%2C0.7%2C0.1%2C0.9l4.2%2C4.2c-0.8%2C2.2-0.3%2C4.9%2C1.4%2C6.5c1.1%2C1.1%2C2.6%2C1.7%2C4.1%2C1.7c0.6%2C0%2C1.1-0.1%2C1.7-0.3l1.2-0.4l-3.8-3.9c-0.3-0.3-0.3-0.8%2C0-1.1l1.5-1.6c0.1-0.1%2C0.3-0.2%2C0.5-0.2h0c0.2%2C0%2C0.5%2C0.1%2C0.6%2C0.3l3.9%2C3.9l0.3-1.3C34.9%2C27.2%2C34.3%2C25.1%2C32.8%2C23.6z%22%2F%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M7%2C12c0.7%2C0%2C1.4-0.1%2C2.1-0.4l4.5%2C4.5c0.3%2C0.3%2C0.8%2C0.3%2C1.1-0.1l2-2.7c0.2-0.3%2C0.2-0.7-0.1-0.9l-4.1-4.1c0.8-2.2%2C0.3-4.9-1.4-6.5C9.5%2C0.2%2C7.3-0.4%2C5.3%2C0.3L4.1%2C0.6l3.9%2C3.9c0.3%2C0.3%2C0.3%2C0.8%2C0%2C1.1L6.4%2C7.1c-0.3%2C0.3-0.9%2C0.3-1.1%2C0l0%2C0L1.4%2C3.2L1.1%2C4.5c-0.5%2C2%2C0%2C4.2%2C1.5%2C5.7C3.7%2C11.3%2C5.3%2C12%2C7%2C12z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 1.1412772196063206,
                scaleY: 1.141277219606321,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752142080525',
                x: 86.44499999999994,
                y: 185.00000000000014,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'What problem are you facing in this room?',
                fontSize: 23,
                fontFamily: 'Open Sans',
                color: '#ffffff',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'center',
                fontVariant: 700,
                align: 'center',
                fill: '#ffffff',
                visible: true,
                width: 326.11,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752142186240',
                x: 139.49999999999994,
                y: 572,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Building, Floor, Room',
                fontSize: 16,
                fontFamily: 'Open Sans',
                color: '#ffffff',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 400,
                textAlign: 'center',
                width: 220,
                fontVariant: 400,
                align: 'center',
                fill: '#ffffff',
                visible: true,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
        ],
        image: 'https://i.ibb.co/S73NmZss/Modern-temp-en.png',
    },
    {
        elements: [
            {
                type: 'pageSize',
                id: 'element1752139646518',
                size: 'A4',
                cuttingGuideStroke: 5,
                cuttingGuideStrokeColor: '#000000',
            },
            {
                id: 'element1752140879571',
                x: 24.25247524752527,
                y: 26.08910891089141,
                fill: '#000000',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 4.504950495049494,
                scaleY: 6.178217821782172,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752141263182',
                x: 149.25247524752461,
                y: 279.7524752475247,
                fill: '#000000',
                stroke: '#ffffff',
                strokeWidth: 1,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 2.0049504950495063,
                scaleY: 2.004950495049506,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                id: 'element1752141318665',
                x: 160.8861386138613,
                y: 291.38613861386136,
                fill: '#FFFFFF',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 1.772277227722773,
                scaleY: 1.772277227722773,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                type: 'qr',
                id: 'element1752140779196',
                width: 110,
                height: 110,
                x: 167.25,
                y: 297.75,
                fill: '#80D965',
                stroke: '#000000',
                strokeWidth: 0,
                draggable: true,
                qrLogo: null,
                qrText: 'https://fixalert.io/',
                opacity: 1,
                logoVisible: false,
                rotation: 0,
                scaleX: 1.4954545454545447,
                scaleY: 1.495454545454545,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                id: 'element1752142031429',
                x: 220.96806950984194,
                y: 79.99999999999994,
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'image',
                draggable: true,
                src: 'data:image/svg+xml,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2034.5%2036.4%22%20width%3D%2250%22%20height%3D%2252%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M29.8%2C4.2c0.7-1%2C0.5-2.3-0.5-3c-0.5-0.3-1-0.5-1.6-0.4c-0.6%2C0.1-1.1%2C0.4-1.4%2C0.9L15.7%2C16l-2.4%2C3.3c-1%2C0.5-7%2C3.2-11.5%2C3.5c0%2C0-0.1%2C0-0.1%2C0c-0.3%2C0-0.5%2C0-0.8%2C0.1c-0.6%2C0.1-0.8%2C0.6-0.9%2C0.8c-0.3%2C1.7%2C0.6%2C3.8%2C2.8%2C6.1c1.5%2C1.7%2C3.2%2C2.9%2C3.2%2C2.9C6.4%2C33%2C6.8%2C33%2C7%2C32.7l2.1-2.3l-1.1%2C3.2c-0.1%2C0.3%2C0%2C0.6%2C0.3%2C0.8c0.1%2C0.1%2C2.6%2C1.6%2C4.3%2C1.9c0.1%2C0%2C0.1%2C0%2C0.2%2C0c0.2%2C0%2C0.4%2C0%2C0.6-0.2c0.6-0.5%2C1.1-1.8%2C1.4-3c0.3-1.2%2C0.6-2.8%2C1-4.8c0.5-2.9%2C0.8-5.7%2C0.9-6.4l2.4-3.3L29.8%2C4.2z%22%2F%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M32.8%2C23.6c-1.1-1.1-2.7-1.8-4.4-1.8c-0.7%2C0-1.4%2C0.1-2.1%2C0.4l-4.6-4.6c-0.3-0.3-0.8-0.3-1.1%2C0.1l-2%2C2.7c-0.2%2C0.3-0.2%2C0.7%2C0.1%2C0.9l4.2%2C4.2c-0.8%2C2.2-0.3%2C4.9%2C1.4%2C6.5c1.1%2C1.1%2C2.6%2C1.7%2C4.1%2C1.7c0.6%2C0%2C1.1-0.1%2C1.7-0.3l1.2-0.4l-3.8-3.9c-0.3-0.3-0.3-0.8%2C0-1.1l1.5-1.6c0.1-0.1%2C0.3-0.2%2C0.5-0.2h0c0.2%2C0%2C0.5%2C0.1%2C0.6%2C0.3l3.9%2C3.9l0.3-1.3C34.9%2C27.2%2C34.3%2C25.1%2C32.8%2C23.6z%22%2F%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M7%2C12c0.7%2C0%2C1.4-0.1%2C2.1-0.4l4.5%2C4.5c0.3%2C0.3%2C0.8%2C0.3%2C1.1-0.1l2-2.7c0.2-0.3%2C0.2-0.7-0.1-0.9l-4.1-4.1c0.8-2.2%2C0.3-4.9-1.4-6.5C9.5%2C0.2%2C7.3-0.4%2C5.3%2C0.3L4.1%2C0.6l3.9%2C3.9c0.3%2C0.3%2C0.3%2C0.8%2C0%2C1.1L6.4%2C7.1c-0.3%2C0.3-0.9%2C0.3-1.1%2C0l0%2C0L1.4%2C3.2L1.1%2C4.5c-0.5%2C2%2C0%2C4.2%2C1.5%2C5.7C3.7%2C11.3%2C5.3%2C12%2C7%2C12z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 1.1412772196063206,
                scaleY: 1.141277219606321,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752142080525',
                x: 86.44499999999994,
                y: 185.00000000000014,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Mit welchem Problem bist du in diesem Raum konfrontiert?',
                fontSize: 23,
                fontFamily: 'Open Sans',
                color: '#ffffff',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'center',
                fontVariant: 700,
                align: 'center',
                fill: '#ffffff',
                visible: true,
                width: 326.11,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752142186240',
                x: 139.49999999999994,
                y: 572,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Gebäude, Stockwerk, Raum',
                fontSize: 16,
                fontFamily: 'Open Sans',
                color: '#ffffff',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 400,
                textAlign: 'center',
                width: 220,
                fontVariant: 400,
                align: 'center',
                fill: '#ffffff',
                visible: true,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
        ],
        image: 'https://i.ibb.co/ns5QvKsw/Modern-temp-de.png',
    },
    {
        elements: [
            {
                type: 'pageSize',
                id: 'element1752139646518',
                size: 'A4',
                cuttingGuideStroke: 5,
                cuttingGuideStrokeColor: '#000000',
            },
            {
                id: 'element1752140879571',
                x: 24.25247524752527,
                y: 26.08910891089141,
                fill: '#000000',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 4.504950495049494,
                scaleY: 6.178217821782172,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752141263182',
                x: 149.25247524752461,
                y: 279.7524752475247,
                fill: '#000000',
                stroke: '#ffffff',
                strokeWidth: 1,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 2.0049504950495063,
                scaleY: 2.004950495049506,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                id: 'element1752141318665',
                x: 160.8861386138613,
                y: 291.38613861386136,
                fill: '#FFFFFF',
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'square',
                draggable: true,
                height: 100,
                width: 100,
                name: 'square',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 1.772277227722773,
                scaleY: 1.772277227722773,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                type: 'qr',
                id: 'element1752140779196',
                width: 110,
                height: 110,
                x: 167.25,
                y: 297.75,
                fill: '#80D965',
                stroke: '#000000',
                strokeWidth: 0,
                draggable: true,
                qrLogo: null,
                qrText: 'https://fixalert.io/',
                opacity: 1,
                logoVisible: false,
                rotation: 0,
                scaleX: 1.4954545454545447,
                scaleY: 1.495454545454545,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                id: 'element1752142031429',
                x: 220.96806950984194,
                y: 79.99999999999994,
                stroke: '#000000',
                strokeWidth: 0,
                opacity: 1,
                type: 'image',
                draggable: true,
                src: 'data:image/svg+xml,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2034.5%2036.4%22%20width%3D%2250%22%20height%3D%2252%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M29.8%2C4.2c0.7-1%2C0.5-2.3-0.5-3c-0.5-0.3-1-0.5-1.6-0.4c-0.6%2C0.1-1.1%2C0.4-1.4%2C0.9L15.7%2C16l-2.4%2C3.3c-1%2C0.5-7%2C3.2-11.5%2C3.5c0%2C0-0.1%2C0-0.1%2C0c-0.3%2C0-0.5%2C0-0.8%2C0.1c-0.6%2C0.1-0.8%2C0.6-0.9%2C0.8c-0.3%2C1.7%2C0.6%2C3.8%2C2.8%2C6.1c1.5%2C1.7%2C3.2%2C2.9%2C3.2%2C2.9C6.4%2C33%2C6.8%2C33%2C7%2C32.7l2.1-2.3l-1.1%2C3.2c-0.1%2C0.3%2C0%2C0.6%2C0.3%2C0.8c0.1%2C0.1%2C2.6%2C1.6%2C4.3%2C1.9c0.1%2C0%2C0.1%2C0%2C0.2%2C0c0.2%2C0%2C0.4%2C0%2C0.6-0.2c0.6-0.5%2C1.1-1.8%2C1.4-3c0.3-1.2%2C0.6-2.8%2C1-4.8c0.5-2.9%2C0.8-5.7%2C0.9-6.4l2.4-3.3L29.8%2C4.2z%22%2F%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M32.8%2C23.6c-1.1-1.1-2.7-1.8-4.4-1.8c-0.7%2C0-1.4%2C0.1-2.1%2C0.4l-4.6-4.6c-0.3-0.3-0.8-0.3-1.1%2C0.1l-2%2C2.7c-0.2%2C0.3-0.2%2C0.7%2C0.1%2C0.9l4.2%2C4.2c-0.8%2C2.2-0.3%2C4.9%2C1.4%2C6.5c1.1%2C1.1%2C2.6%2C1.7%2C4.1%2C1.7c0.6%2C0%2C1.1-0.1%2C1.7-0.3l1.2-0.4l-3.8-3.9c-0.3-0.3-0.3-0.8%2C0-1.1l1.5-1.6c0.1-0.1%2C0.3-0.2%2C0.5-0.2h0c0.2%2C0%2C0.5%2C0.1%2C0.6%2C0.3l3.9%2C3.9l0.3-1.3C34.9%2C27.2%2C34.3%2C25.1%2C32.8%2C23.6z%22%2F%3E%3Cpath%20class%3D%22st0%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M7%2C12c0.7%2C0%2C1.4-0.1%2C2.1-0.4l4.5%2C4.5c0.3%2C0.3%2C0.8%2C0.3%2C1.1-0.1l2-2.7c0.2-0.3%2C0.2-0.7-0.1-0.9l-4.1-4.1c0.8-2.2%2C0.3-4.9-1.4-6.5C9.5%2C0.2%2C7.3-0.4%2C5.3%2C0.3L4.1%2C0.6l3.9%2C3.9c0.3%2C0.3%2C0.3%2C0.8%2C0%2C1.1L6.4%2C7.1c-0.3%2C0.3-0.9%2C0.3-1.1%2C0l0%2C0L1.4%2C3.2L1.1%2C4.5c-0.5%2C2%2C0%2C4.2%2C1.5%2C5.7C3.7%2C11.3%2C5.3%2C12%2C7%2C12z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E',
                strokeScaleEnabled: false,
                rotation: 0,
                scaleX: 1.1412772196063206,
                scaleY: 1.141277219606321,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752142080525',
                x: 86.44499999999994,
                y: 185.00000000000014,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Zgłoś problem',
                fontSize: 23,
                fontFamily: 'Open Sans',
                color: '#ffffff',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'center',
                fontVariant: 700,
                align: 'center',
                fill: '#ffffff',
                visible: true,
                width: 326.11,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
            {
                id: 'element1752142186240',
                x: 139.49999999999994,
                y: 572,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Budynek, Piętro, Pokój',
                fontSize: 16,
                fontFamily: 'Open Sans',
                color: '#ffffff',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 400,
                textAlign: 'center',
                width: 220,
                fontVariant: 400,
                align: 'center',
                fill: '#ffffff',
                visible: true,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                offsetX: 0,
                offsetY: 0,
                skewX: 0,
                skewY: 0,
            },
        ],
        image: 'https://i.ibb.co/JRzpFxtH/Modern-temp-pl.png',
    },
];
export const defaultTemplates = [
    {
        image: ImageTemplate1,
        title: 'temp-name',
        elements: [
            {
                type: 'pageSize',
                id: 'element1744780067175',
                size: 'Ledger',
            },
            {
                id: 'element1744780116472',
                x: 134.58287570698877,
                y: 95.49999999999956,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Default Template 1',
                fontSize: 16,
                fontFamily: 'Open Sans',
                color: '#eee8e8',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'left',
                fontVariant: 700,
                align: 'left',
                fill: '#eee8e8',
                visible: true,
                width: 172.92,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                type: 'backgroundColor',
                id: 'element1744780122624',
                color: '#7e1515',
            },
        ],
    },
    {
        image: ImageTemplate2,
        title: 'temp-name',
        elements: [
            {
                type: 'pageSize',
                id: 'element1744780067175',
                size: 'A4',
            },
            {
                id: 'element1744780116472',
                x: 134.58287570698877,
                y: 95.49999999999956,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Default Template 2',
                fontSize: 16,
                fontFamily: 'Open Sans',
                color: '#eee8e8',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'left',
                fontVariant: 700,
                align: 'left',
                fill: '#eee8e8',
                visible: true,
                width: 172.92,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                type: 'backgroundColor',
                id: 'element1744780122624',
                color: '#7e1515',
            },
        ],
    },
];

export const customTemplates = [
    {
        image: ImageCustomTemplate1,
        title: 'Custom temp-1',
        elements: [
            {
                type: 'pageSize',
                id: 'element1744780067175',
                size: 'A4',
            },
            {
                id: 'element1744780116472',
                x: 134.58287570698877,
                y: 95.49999999999956,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Custom Template 1',
                fontSize: 16,
                fontFamily: 'Open Sans',
                color: '#eee8e8',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'left',
                fontVariant: 700,
                align: 'left',
                fill: '#eee8e8',
                visible: true,
                width: 172.92,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                type: 'backgroundColor',
                id: 'element1744780122624',
                color: '#7e1515',
            },
        ],
    },
    {
        image: ImageCustomTemplate2,
        title: 'Custom2',
        elements: [
            {
                type: 'pageSize',
                id: 'element1744780067175',
                size: 'A4',
            },
            {
                id: 'element1744780116472',
                x: 134.58287570698877,
                y: 95.49999999999956,
                opacity: 1,
                type: 'text',
                draggable: true,
                text: 'Custom Template 2',
                fontSize: 16,
                fontFamily: 'Open Sans',
                color: '#eee8e8',
                textDecoration: 'normal',
                fontStyle: 'normal',
                fontWeight: 700,
                textAlign: 'left',
                fontVariant: 700,
                align: 'left',
                fill: '#eee8e8',
                visible: true,
                width: 172.92,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                skewX: 0,
                skewY: 0,
                offsetX: 0,
                offsetY: 0,
            },
            {
                type: 'backgroundColor',
                id: 'element1744780122624',
                color: '#7e1515',
            },
        ],
    },
];

export const normalFonts = [
    'Open Sans',
    'Roboto',
    'Lato',
    'Montserrat',
    'Source Sans Pro',
    'Inter',
    'Raleway',
    'Poppins',
    'Merriweather',
    'Noto Sans',
    'Work Sans',
    'Ubuntu',
    'Nunito',
    'Playfair Display',
    'DM Sans',
    'PT Sans',
    'Quicksand',
    'Baloo 2',
    'Amatic SC',
    'Plus Jakarta Sans',
    'Rubik',
    'Oswald',
    'Kalam',
    'Caveat',
];
export const funkyFonts = [
    'Open Sans Condensed',
    'Lobster',
    'Pacifico',
    'Bangers',
    'Shadows Into Light',
    'Indie Flower',
    'Fredericka the Great',
    'Chewy',
    'Coming Soon',
    'Gloria Hallelujah',
    'Luckiest Guy',
    'Patrick Hand',
    'Rock Salt',
    'Architects Daughter',
    'Boogaloo',
    'Concert One',
    'Courgette',
    'Great Vibes',
    'Handlee',
    'Mansalva',
    'Satisfy',
    'Special Elite',
    'Titan One',
];

export const fontFamilies = [...normalFonts, ...funkyFonts];
